import React, { useState } from "react";
import PropTypes from "prop-types";
import { Box, Paper, Checkbox, FormControlLabel } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { useTranslation } from "react-i18next";
import TooltipButton from "../Buttons/TooltipButton";
import { useActivityCompletions } from "../../hooks/learningCenter/activityCompletions";
import { useSnackbarNotifications } from "../../hooks/snackbar";

const useStyles = makeStyles(theme => ({
  rootContainer: {
    padding: theme.spacing(7),
    marginBottom: theme.spacing(3)
  },
  textBodyContainer: {
    "& > p": {
      paddingBottom: theme.spacing(2.5)
    }
  }
}));

const PolicyAcknowledgement = ({
  textBody,
  alowSubmit,
  isComplete,
  trainingObjectId,
  courseContentableId,
  onSubmitSuccess
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [isChecked, setIsChecked] = useState(isComplete);
  const { createActivityCompletion, isCreating } = useActivityCompletions();
  const { displayErrorMessage } = useSnackbarNotifications();

  const handleSubmit = () => {
    createActivityCompletion({
      courseContentable: { type: "courseContentable", id: courseContentableId },
      trainingObject: { type: "trainingObject", id: trainingObjectId }
    }).then(response => {
      if (response.ok) {
        onSubmitSuccess();
      } else {
        displayErrorMessage(
          t("contentViewer.policyAcknowledgement.submitErrorMsg")
        );
      }
    });
  };
  return (
    <Paper className={classes.rootContainer}>
      <Box mb={5}>
        <Box
          display="flex"
          flexDirection="row"
          color="textSecondary"
          mt={3}
          className={classes.textBodyContainer}
        >
          <FormControlLabel
            value="end"
            control={
              <Checkbox
                className={classes.checkbox}
                onChange={(event, checked) => setIsChecked(checked)}
                checked={isChecked}
                disabled={isComplete || isCreating}
              />
            }
            label={
              textBody &&
              textBody.length > 0 && (
                <>
                  <div dangerouslySetInnerHTML={{ __html: textBody }} />
                </>
              )
            }
            labelPlacement="end"
          />
        </Box>
      </Box>
      <Box display="flex" justifyContent="flex-end">
        <TooltipButton
          color="primary"
          variant="contained"
          onClick={handleSubmit}
          disabled={!alowSubmit || !isChecked || isComplete || isCreating}
          data-qa="policy-acknowledgement-submit-btn"
          tooltipProps={{
            title:
              alowSubmit || isComplete
                ? ""
                : t("contentViewer.policyAcknowledgement.submitTooltip")
          }}
        >
          {t("contentViewer.policyAcknowledgement.submitBtn")}
        </TooltipButton>
      </Box>
    </Paper>
  );
};

export default PolicyAcknowledgement;

PolicyAcknowledgement.propTypes = {
  trainingObjectId: PropTypes.number,
  courseContentableId: PropTypes.number,
  textBody: PropTypes.string,
  alowSubmit: PropTypes.bool,
  isComplete: PropTypes.bool,
  onSubmitSuccess: PropTypes.func
};
